import SvgIcon from '@gef-ui/components/atoms/SvgIcon/SvgIcon';

SvgIcon.defaultProps = {
	...(SvgIcon.defaultProps || {}),
};
